import { createFileRoute, Outlet } from '@tanstack/react-router'
import EntityTypeRulesTab from '@admin/preferences/entities/EntityTypeRulesTab'

export const Route = createFileRoute('/_auth/preferences/entityTypes/$entityTypeId/rules')({
  component: RouteComponent,
})

function RouteComponent() {
  const { entityType } = Route.useRouteContext()

  return (
    <>
      <EntityTypeRulesTab entityType={entityType} />
      <Outlet />
    </>
  )
}
